import React, { useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import ProviderTransactionListComponent from "components/ProviderReports/Transaction"
import {
  exportProviderReceiptHealthReport,
  exportProviderReceiptReport,
  exportProviderTransactions,
  getProviderReceiptHealthReports,
  getProviderReceiptReports,
  getProviderTransactions,
} from "store/provider-reports/p-report-action"
import {
  getProviderItemCategories,
  getProviderWarehouses,
} from "store/provider-dashboard/provider-dashboard-action"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import ProviderReceiptReportListComponent from "components/ProviderReports/Receipt"
import ProviderReceiptHealthReportListComponent from "components/ProviderReports/ReceiptHealth"

const ProviderReceiptHealthReportList = () => {
  // Meta title
  document.title = "Receipt Health Reports"

  const dispatch = useDispatch()

  // Retrieve warehouse data from Redux store
  const receipts = useSelector(
    state => state.providerReports.providerReceiptHealthReport
  )

  // Current status of the export process for the report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.providerReports.providerReceiptHealthExport
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_RECEIPT_HEALTH
  )


  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProviderReceiptHealthReports(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProviderReceiptHealthReports(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProviderReceiptHealthReports(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch data for filter
  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderWarehouses())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getProviderReceiptHealthReports(
        undefined,
        undefined,
        undefined,
        search,
        data
      )
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProviderReceiptHealthReport(pageNumber,
        according,
        search,
        advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs
        title={"Provider"}
        breadcrumbItem={"Receipt Health Reports"}
      />
      {/* Provider Reciept Health Report List Component  */}
      <ProviderReceiptHealthReportListComponent
        data={receipts?.data}
        error={receipts?.error}
        loading={receipts?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default ProviderReceiptHealthReportList
